import { Icon, IconProps } from "@chakra-ui/react"

const ProfileIcon = (props: IconProps) => (
  <Icon
    width='24px'
    height='20px'
    viewBox='0 0 24 20'
    fill='none'
    className='icon'
    {...props}
  >
    <g clipPath='url(#clip0_1319_5085)'>
      <mask
        id='mask0_1319_5085'
        maskUnits='userSpaceOnUse'
        x='0'
        y='0'
        width='18'
        height='18'
      >
        <path d='M18 0H0V18H18V0Z' fill='white' />
      </mask>
      <g mask='url(#mask0_1319_5085)'>
        <path
          d='M9 0C7.21997 0 5.47991 0.527841 3.99987 1.51677C2.51983 2.50571 1.36628 3.91131 0.685088 5.55585C0.00389957 7.20038 -0.17433 9.00998 0.172937 10.7558C0.520203 12.5016 1.37737 14.1053 2.63604 15.364C3.89472 16.6226 5.49836 17.4798 7.24419 17.8271C8.99002 18.1743 10.7996 17.9961 12.4442 17.3149C14.0887 16.6337 15.4943 15.4802 16.4832 14.0001C17.4722 12.5201 18 10.78 18 9C17.9974 6.61386 17.0483 4.32622 15.361 2.63896C13.6738 0.951708 11.3861 0.00264685 9 0ZM12.2 16.033C11.1965 16.4893 10.1069 16.7254 9.0045 16.7254C7.90212 16.7254 6.81252 16.4893 5.809 16.033V12.919C5.80953 12.4971 5.97729 12.0926 6.27552 11.7942C6.57375 11.4958 6.97812 11.3278 7.4 11.327H10.6C10.8097 11.3262 11.0174 11.3668 11.2114 11.4464C11.4053 11.526 11.5817 11.6432 11.7303 11.791C11.8789 11.9389 11.9969 12.1147 12.0775 12.3082C12.1581 12.5018 12.1997 12.7093 12.2 12.919V16.033ZM13.47 15.3V12.92C13.4695 12.1593 13.1668 11.4299 12.6286 10.8923C12.0904 10.3546 11.3607 10.0527 10.6 10.053H10.441C11.1262 9.72541 11.6798 9.17463 12.0107 8.49104C12.3417 7.80745 12.4305 7.03166 12.2626 6.29096C12.0946 5.55025 11.6799 4.88864 11.0864 4.41467C10.493 3.9407 9.75601 3.68254 8.9965 3.68254C8.237 3.68254 7.50005 3.9407 6.90658 4.41467C6.31311 4.88864 5.89837 5.55025 5.73042 6.29096C5.56246 7.03166 5.65127 7.80745 5.98226 8.49104C6.31326 9.17463 6.86678 9.72541 7.552 10.053H7.4C6.63944 10.0527 5.9099 10.3545 5.37173 10.8919C4.83356 11.4293 4.5308 12.1584 4.53 12.919V15.3C3.19313 14.3517 2.19248 13.0028 1.67273 11.4483C1.15298 9.89385 1.14107 8.21436 1.63871 6.65267C2.13636 5.09098 3.11777 3.72802 4.44106 2.76084C5.76435 1.79367 7.36094 1.2724 9 1.2724C10.6391 1.2724 12.2357 1.79367 13.5589 2.76084C14.8822 3.72802 15.8637 5.09098 16.3613 6.65267C16.8589 8.21436 16.847 9.89385 16.3273 11.4483C15.8075 13.0028 14.8069 14.3517 13.47 15.3ZM9 9.106C8.58961 9.106 8.18843 8.9843 7.8472 8.7563C7.50596 8.5283 7.24001 8.20422 7.08295 7.82507C6.9259 7.44591 6.88481 7.0287 6.96487 6.62619C7.04494 6.22368 7.24256 5.85395 7.53276 5.56375C7.82295 5.27356 8.19268 5.07593 8.59519 4.99587C8.9977 4.91581 9.41492 4.9569 9.79407 5.11395C10.1732 5.271 10.4973 5.53696 10.7253 5.87819C10.9533 6.21942 11.075 6.6206 11.075 7.031C11.0745 7.58116 10.8557 8.10864 10.4667 8.49766C10.0776 8.88668 9.55017 9.10547 9 9.106Z'
          fill='#414141'
        />
      </g>
    </g>
    <defs>
      <clipPath id='clip0_1319_5085'>
        <rect width='18' height='18' fill='white' />
      </clipPath>
    </defs>
  </Icon>
)

export default ProfileIcon
